const { useState, useEffect } = require('react');
const { useDispatch } = require('react-redux');

/**
 * To create file download hook.
 * To see the usage, checkout useDownloadEdgeFile hook creation in edgeFileExport.service.js.
 * @param {function} downloadAction action to download the file that acceepts id of the file.
 * To see reference of code for download action, checkout downloadEdgeFile function in edgeFileExport.service.js.
 * @returns Created hook to handle file download for dispatched action.
 */
export const createDownloadFileHook = (downloadAction) => () => {
  // Action dispatcher
  const dispatch = useDispatch();
  /**
   * Local state to indicate that file download request is currently in progress.
   */
  const [ downloading, setDownloading ] = useState(false);

  /**
   * Id of the file to download. This will be supplied to downloadAction.
   */
  const [ downloadId, setDownloadId ] = useState('');

  /**
   * To instruct the hook about id of the file to download.
   * @param {Id} id id of the file to download
   * @returns {void}
   */
  const downloadFile = (id) => setDownloadId(id);

  useEffect(() => {
    if (!downloadId) {
      return;
    }

    (async () => {
      setDownloading(true);
      await dispatch(downloadAction(downloadId));
      setDownloading(false);
      // clear the id after downloa.
      setDownloadId('');
    })();
  }, [ dispatch, downloadId ]);

  return { downloading, downloadFile, downloadId };
};
